import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ServicePage from "@/pages/ServicePage";

export const Route = createFileRoute("/en/services/$slug")({
  head: ({ params }) => buildRouteHead(`/en/services/${params.slug}`),
  component: ServicePage,
});

